var API_DOMAIN  = "https://jaivanthcrackers.zentexus.com/api";

export default API_DOMAIN